module.exports = __webpack_public_path__ + "static/media/wizualizacja-11.0acfefa3.png";